module.exports = __webpack_public_path__ + "img/part-3-title.5f9392bc.png";